export interface ServiceDeliveryPoint {
  id: string;
  address1: string;
  address2: string;
  alternateIds: Record<string, any>;
  associatedClassicChildNodeIds: string[];
  city: string;
  commodity: string;
  country: string;
  defaultLocale: string;
  descriptions: Record<string, string>;
  description: string;
  displayLabels: Record<string, string>;
  displayLabel: string;
  endDttm: string;
  postalCode: string;
  sdpType: string;
  shortDisplayLabels: Record<string, string>;
  spaceType: string;
  startDttm: string;
  state: string;
  status: string;
  timezone: string;
  utilityMeterNumber: string;
  siteId: string;
  parentId: string;
}

export interface StatusOption {
  id: string;
  displayLabel: string;
}

export let statuses: StatusOption[] = [
  {
    id: 'ACTIVE',
    displayLabel: 'utility.account.statuses.active',
  },
  {
    id: 'INACTIVE',
    displayLabel: 'utility.account.statuses.inactive',
  },
];

export interface SDPsDataObject {
  sdps: ServiceDeliveryPoint[];
  hasError: boolean;
  errorMessage?: string;
  selectFirst?: boolean;
  selectSdpId?: string;
  isLoading?: boolean;
}

export enum ServiceDeliveryPointStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum PageType {
  CREATE = 'create',
  EDIT = 'edit',
  VIEW = 'view',
}

export interface ErrorState {
  message: string;
  hasError: boolean;
}

export interface Commodity {
  id: string;
  name: string;
  description?: string;
  code?: string;
}

export interface Type {
  id: string;
  name: string;
  description?: string;
  code?: string;
}

export interface FormStatus {
  status: string;
  valid: boolean;
  invalid: boolean;
  pending: boolean;
  pristine: boolean;
  dirty: boolean;
}

export interface MultiLocaleFormData {
  localeInputsForm_sdp_display_labels?: Record<string, string>;
  localeInputsForm_sdp_description_display_labels?: Record<string, string>;
}

export interface MultiLocaleComponent {
  form: {
    valueChanges: any;
    status: string;
  };
}
